import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../../data/landing';
type View = 'antes' | 'despues';
export function BeforeAfterSection() {
  const [view, setView] = useState<View>('antes');
  return <section className="bg-beige-100 py-12 sm:py-24" data-id="element-96" data-mp="3ffll61kl9a3w">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-97" data-mp="3fgdgdba9x5tn">
        <h2 className="text-center font-serif text-[1.9rem] leading-tight text-petrol-800 text-balance sm:text-5xl" data-id="element-98" data-mp="701unabay5sj">
          Dejá de empezar cada consulta <span className="italic text-terra-500" data-id="element-99" data-mp="3tebjtln23hud">desde cero.</span>
        </h2>

        {/* Mobile: comparador interactivo */}
        <div className="mt-7 md:hidden" data-id="element-100" data-mp="278s8t3b39jm">
          <div role="tablist" aria-label="Comparar" className="relative grid grid-cols-2 rounded-full bg-paper p-1" data-id="element-101" data-mp="267hkpq7cp2f">
            {(['antes', 'despues'] as View[]).map(v => <button key={v} type="button" role="tab" aria-selected={view === v} onClick={() => setView(v)} className={`relative z-10 rounded-full py-2.5 text-xs font-bold uppercase tracking-wide transition-colors duration-150 ease-out ${view === v ? v === 'antes' ? 'text-petrol-900' : 'text-cream' : 'text-ink/50'}`} data-id="element-102" data-mp="uol2joqfwgk3">
                {view === v && <motion.span layoutId="ba-pill" transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className={`absolute inset-0 -z-10 rounded-full ${v === 'antes' ? 'bg-beige-200' : 'bg-petrol-800'}`} data-id="element-103" data-mp="2cf8n1rydoqb9" />}
                {v === 'antes' ? 'Antes' : 'Con el kit'}
              </button>)}
          </div>

          <div className={`mt-3 overflow-hidden rounded-2xl transition-colors duration-200 ease-out ${view === 'antes' ? 'bg-paper' : 'bg-petrol-800'}`} data-id="element-104" data-mp="2vdbh4l5s9dfx">
            <AnimatePresence mode="wait" initial={false} data-id="element-105" data-mp="2qegqix1kqkl9">
              <motion.ul key={view} initial={{
              opacity: 0,
              x: view === 'despues' ? 12 : -12
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.18,
              ease: [0.23, 1, 0.32, 1]
            }} className="px-4 py-2" data-id="element-106" data-mp="10xz5xc2q2ad4">
                {(view === 'antes' ? beforeItems : afterItems).map(item => <Row key={item} item={item} positive={view === 'despues'} data-id="element-107" data-mp="1un6lgsmlq6tx" />)}
              </motion.ul>
            </AnimatePresence>
          </div>
          {view === 'antes' && <button type="button" onClick={() => setView('despues')} className="mx-auto mt-3 block text-sm font-semibold text-terra-600 underline underline-offset-4" data-id="element-108" data-mp="24lmdcxtgdk4h">
              Ver cómo cambia con el kit →
            </button>}
        </div>

        {/* Desktop: tabla lado a lado */}
        <div className="mt-12 hidden overflow-hidden rounded-3xl md:grid md:grid-cols-2" data-id="element-109" data-mp="2iebzd28zep1l">
          <div className="bg-paper px-10 py-8" data-id="element-110" data-mp="2ndowqgxhbeif">
            <h3 className="text-sm font-bold uppercase tracking-[0.16em] text-ink/50" data-id="element-111" data-mp="2nf00whuu6oa2">Antes</h3>
            <ul className="mt-4" data-id="element-112" data-mp="2schzpff53n4c">
              {beforeItems.map(item => <Row key={item} item={item} positive={false} data-id="element-113" data-mp="gp6g9a3txdhp" />)}
            </ul>
          </div>
          <div className="bg-petrol-800 px-10 py-8" data-id="element-114" data-mp="bpaab5bknbzi">
            <h3 className="text-sm font-bold uppercase tracking-[0.16em] text-gold-300" data-id="element-115" data-mp="brwi962djti9">Con Kit Sexualidad Práctica</h3>
            <ul className="mt-4" data-id="element-116" data-mp="1rnhrg1cnlx2">
              {afterItems.map(item => <Row key={item} item={item} positive data-id="element-117" data-mp="1t6x94f6lsxs" />)}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-center font-serif text-2xl leading-tight text-petrol-800 sm:mt-12 sm:text-4xl" data-id="element-118" data-mp="zeuvluv76lby">
          Menos tiempo creando material.
          <br data-id="element-119" data-mp="ppb8gd0gc5ba" />
          <span className="text-terra-500" data-id="element-120" data-mp="pot56wfdgqtv">Más tiempo en tu práctica.</span>
        </p>
      </div>
    </section>;
}
function Row({
  item,
  positive
}: {
  item: string;
  positive: boolean;
}) {
  return <li className={`flex items-center gap-3 border-b py-3 text-[15px] last:border-b-0 sm:py-4 ${positive ? 'border-petrol-700 font-medium text-cream' : 'border-beige-200 text-ink/60'}`} data-id="element-121" data-mp="1i65h1wi5m5wg">
      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-terra-500 text-cream' : 'bg-beige-200 text-ink/50'}`} data-id="element-122" data-mp="xwmh6bncbxvf">
        {positive ? <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-123" data-mp="12tw6zsen6bjs" /> : <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-124" data-mp="o0sx877al23m" />}
      </span>
      {item}
    </li>;
}